import { useWindowSize } from './useWindowSize';

type Breakpoints = {
  isXSmall: boolean;
  isSmall: boolean;
  isMedium: boolean;
  isLarge: boolean;
  isXLarge: boolean;
};

const breakpoints = {
  xs: '16px',
  sm: '600px',
  md: '960px',
  lg: '1280px',
  xl: '1920px',
};

function useBreakpoints(debounceDelay = 100): Breakpoints {
  const windowSize = useWindowSize(debounceDelay);

  const isXSmall =
    !!windowSize.width && windowSize.width >= parseInt(breakpoints.xs);
  const isSmall =
    !!windowSize.width && windowSize.width >= parseInt(breakpoints.sm);
  const isMedium =
    !!windowSize.width && windowSize.width >= parseInt(breakpoints.md);
  const isLarge =
    !!windowSize.width && windowSize.width >= parseInt(breakpoints.lg);
  const isXLarge =
    !!windowSize.width && windowSize.width >= parseInt(breakpoints.xl);

  return { isXSmall, isSmall, isMedium, isLarge, isXLarge };
}

export { useBreakpoints };
